/**
 * The phone's words for notes, photos and contact actions (piece 35, batch MA5;
 * decisions 4201, 4280), spread into the one string lookup beside the first
 * release's. A word the web already says, such as Add Note, Open, Call, Email,
 * Cancel or Scan pending, is read from the web's own key and is not repeated here.
 */
export const NOTES_FILES_STRINGS = {
  'mobile.notes.refused': 'The server refused the note.',
  'mobile.notes.unsent': 'The note was not saved, because the server did not answer. Check the connection, then add it again.',
  'mobile.files.takePhoto': 'Take Photo',
  'mobile.files.choosePhoto': 'Choose Photo',
  'mobile.files.uploading': 'Filing the photo…',
  'mobile.files.notFiled': 'The photo was not filed.',
  'mobile.files.notPrepared': 'The phone could not prepare it to send.',
  'mobile.files.notKept': 'The phone does not keep it: Retry sends it again while this page stays open.',
  'mobile.files.typesRefused': 'The file types could not be read, so no photo can be filed here.',
  'mobile.files.noType': 'No file type applies to this record, so no photo can be filed here.',
  'mobile.files.cameraRefused': 'The phone refused the camera. Allow the camera for this app in the phone’s Settings, then try again.',
  'mobile.files.moreOnWeb': 'The first {count} files are listed here. The rest are on the web.',
  'mobile.files.openFailed': 'The file did not open.',
  'mobile.files.purged': 'Purged, cannot be restored',
  'mobile.files.noViewer': 'This phone has no viewer to hand the file to.',
  'mobile.contact.text': 'Text',
  'mobile.contact.refused': 'The phone could not hand this off.',
} as const;
